import ScrollTo from './ScrollTo';

export default class ProductInfo {

    static init() {
        if (window.matchMedia('(min-width: 1280px)').matches) {
            const navLinks = document.querySelectorAll('.product-info-nav__link');
            let linkClass = 'product-info-nav__link--active';
            let itemClass = 'product-info__item--active';

            if (navLinks.length > 0) {
                navLinks.forEach(link => {
                    link.addEventListener('click', e => {
                        e.preventDefault();
                        let el = link.getAttribute('href');
                        if (el) {
                            let elNode = document.querySelector(el);
                            if (elNode) {
                                let currentLink = document.querySelector(`.${linkClass}`);
                                let currentItem = document.querySelector(`.${itemClass}`);
                                currentLink.classList.remove(linkClass);
                                currentItem.classList.remove(itemClass);
                                link.classList.add(linkClass);
                                elNode.classList.add(itemClass);
                            }
                        }
                    });
                });
            }
        }
    }

    static scrollToProductInfo() {
        const trigger = document.getElementById('jsScrollToProductInfo');

        if (trigger) {
            trigger.addEventListener('click', e => {
                e.preventDefault();
                ScrollTo.doScrolling('#productInfo', 500);
                if (window.matchMedia('(max-width: 1279px)').matches) {
                    const accordion = document.querySelector('.product-info__header.jsAccordionHeader');
                    if (accordion) {
                        accordion.click();
                    }
                }
            });
        }
    }

    static handleExternalTriggers() {
        const triggers = document.querySelectorAll('.jsOpenProductInfoTab');

        if (triggers.length > 0) {
            triggers.forEach(trigger => {
                trigger.addEventListener('click', e => {
                   e.preventDefault();
                   let tabIndex = trigger.getAttribute('href');
                   let links;

                   if (window.matchMedia('(min-width: 1280px)').matches) {
                       links = document.querySelectorAll('.product-info-nav__link');
                   } else {
                       links = document.querySelectorAll('.jsAccordionHeader');
                   }

                    if (tabIndex && links.length > 0) {
                        if (links[tabIndex-1]) {
                            links[tabIndex-1].click();
                        }
                    }
                });
            });
        }
    }
}
